<template>
  <div class="mt-4 mb-2">
    <h3 class="custom-title pa-0 mt-4 mb-2">
      {{ $t("headers.emails_linked") }}
    </h3>
    <ul>
      <li v-for="(item, index) in showAll ? emails : emails.slice(0, 3)" :key="index">
        <span
          :style="{ opacity: opacityPercentage(index) }"
          class="flex-grow-1 flex-shrink-1"
          >{{ item.email }}</span
        >
        <span
          v-if="item.email === emailCredential"
          :style="{ opacity: opacityPercentage(index) }"
          class="ball"
          >{{ $t("fields.you").toUpperCase() }}</span
        >
        <span
          v-if="item.email !== emailCredential"
          :style="{ opacity: opacityPercentage(index) }"
          class="ball"
        ></span>
      </li>
    </ul>
    <hr v-if="emails.length > 3" />
    <v-btn
      v-if="emails.length > 3"
      class="accent--text"
      @click="toggle()"
      outlined
      block
    >
      {{ showButton ? $t("accounts.show_all") : $t("accounts.show_less") }}
    </v-btn>
  </div>
</template>

<script>
import credentialMixins from '@/mixins/Credentials'
export default {
  props: {
    webappUser: Object,
    webappUserCredentials: Array,
  },
  data () {
    return {
      emails: this.webappUserCredentials,
      emailCredential: '',
      showAll: false,
      showButton: true,
    }
  },
  methods: {
    toggle () {
      this.showAll = !this.showAll
      if (this.showAll) {
        this.showButton = false
      } else {
        this.showButton = true
      }
    },
    opacityPercentage (index) {
      if (!this.showAll) return 1 / index
      else return 1
    },
  },
  created () {
    this.emailCredential = this.getCredentialFromToken(this.webappUserCredentials)
    if (!this.emailCredential) {
      return
    }
    const userIndex = this.webappUserCredentials.findIndex((c) => c.id === this.emailCredential.id)
    const item = this.webappUserCredentials.splice(userIndex, 1)
    this.webappUserCredentials.splice(0, 0, item[0])
    if (this.emails.length <= 3) {
      this.showAll = true
      this.showButton = false
    }
  },
  mixins: [ credentialMixins ],
}
</script>

<style lang="scss" scoped>
hr {
  border: 1px solid var(--v-primary-darken1);
  margin-top: 2vh;
  margin-bottom: 15px;
}
.custom-title {
  overflow-wrap: break-word !important;
  font-size: 1.25rem !important;
  font-weight: 500;
  letter-spacing: 0.0125em !important;
  line-height: 2rem;
  font-family: Roboto, sans-serif !important;
  color: rgba(0, 0, 0, 0.6);
}
.v-application ol,
.v-application ul {
  padding-left: 0 !important;
}
ul {
  padding: 0px;
  width: 100%;
}
li {
  display: inline-flex;
  width: 100%;
  display: flex;
  height: 35px;
  align-content: space-between;
  align-items: baseline;
}
@media (max-width: 510px) {
  li {
    height: 45px;
  }
}
@media (max-width: 326px) {
  li {
    height: 65px;
  }
}
span {
  line-height: 26px;
  font-size: 16px;
  display: flex;
  align-items: center;
  padding-bottom: 0px;
  padding-bottom: 0px;
  margin-left: 0px;
  margin-right: 0px;
  height: 100%;
}
.ball {
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 9px;
}
.ball::after {
  content: "";
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  background: var(--v-custom-grey-lighten1);
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}
li:first-child .ball::after {
  background: var(--v-primary-lighten1);
}
.hide {
  display: none;
}
.v-btn--outlined {
  border: thin solid #dcdcdc;
}
</style>
